import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	placeholder: {
		id: 'admin-pages-issue-type-screen-schemes-page.issue-type-screen-scheme-search-box.placeholder',
		defaultMessage: 'Filter by name',
		description: 'Text (placeholder) displayed when user did not fill filter query in search input',
	},
});
